<div class="banner block border-radius">
  <img
    src="assets/travel.jpg"
    width="1500"
    height="735"
    alt="Travel"
    class="banner__image"
  />
  <div class="banner__content">
    <div class="heading heading_large heading_centered">Travel & Adventure</div>
    <p>
      A major addition to the collection of travel images from various countries
      around the world
    </p>
    <a routerLink="/gallery" class="button button_large button_light-outlined">
      Explore images
    </a>
  </div>
</div>
